import { VisuallyHidden } from "@reach/visually-hidden";
import classNames from "classnames";
import Clickable from "components/Clickable";
import { CmsResponsiveImage } from "components/CmsResponsiveImage";
import { imagePlaceholder } from "helpers/utils";
import { AttributeOptionFunction } from "interfaces/products";
import { useState } from "react";

import { FunctionModal } from ".";

import styles from "./function-list.module.scss";

export const FunctionList = ({
    functions,
}: {
    functions: AttributeOptionFunction[];
}) => {
    const [showFunctionModal, setShowFunctionModal] = useState(false);

    return (
        <section className={styles.availableFunctions}>
            <h2 className={styles.heading}>Available Functions</h2>
            <FunctionModal
                functions={functions}
                isOpen={showFunctionModal}
                close={() => setShowFunctionModal(false)}
            />
            <ul role="list" className={styles.list}>
                {functions.map((item) => (
                    <li key={item.id} className={styles.listItem}>
                        <CmsResponsiveImage
                            decorative={true}
                            cmsImage={
                                item.function_modal?.image ?? {
                                    url: imagePlaceholder,
                                }
                            }
                            className={styles.image}
                            sizes="70px"
                            cldSrcSet={[70, 140, 210, 280]}
                            cloudinaryProps={{
                                aspectRatio: "1:1",
                                crop: "fill",
                                type: item.function_modal?.image
                                    ? "fetch"
                                    : "upload",
                            }}
                        />
                        {item.function_modal
                            ? item.function_modal.title
                            : item.option}
                    </li>
                ))}
            </ul>
            <Clickable
                className={classNames([styles.clickable, "al-pdp-af__trigger"])}
                onClick={() => setShowFunctionModal(true)}
            >
                <VisuallyHidden>
                    View More Product Function Information
                </VisuallyHidden>
            </Clickable>
        </section>
    );
};
